import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { userActions } from '../models/enums/user-permissions.enum';
import { UserUtilityService } from '../services/user-utility.service';

@Injectable({
    providedIn: 'root',
})
export class CreateAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private user_utility: UserUtilityService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let flg_Authorized;
        return this.user_utility.checkUserPermissionDataAndRoute(route.routeConfig.path, userActions.Create).then((res) => {
            flg_Authorized = res;
            if (flg_Authorized) {
                return flg_Authorized;
            } else {
                this.router.navigate(['/401']);
                return flg_Authorized;
            }
        });
    }
}
